import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import Program from '../../../../Model/Program';
import Select from '../../../../components/Select';
import texts from './texts.json';

const ChallengeProgramSelector = ({
  programs,
  selectedProgramId,
  onChange,
  isReadOnly,
  hasError,
  errorId,
}) => {
  const programOptions = useMemo(() => {
    const sortedPrograms = programs.slice().sort((a, b) => a.name.localeCompare(b.name));

    // Only show programs that are not archived and are not empty. A program is
    // considered empty when none of its workout days reference an actual workout
    // (rest days persist as `{ workoutRef: null }`), which would let a challenge
    // contract be created against a program with no workouts.
    const options = sortedPrograms
      .filter((program) => !program.isArchived
        && program.workouts.some((workout) => !!workout?.workoutRef))
      .map((program) => ({
        value: program.id,
        label: program.name,
      }));

    return [
      {
        value: '',
        label: texts.none,
      },
      ...options,
    ];
  }, [programs]);

  return (
    <Select
      value={selectedProgramId}
      onChange={(e) => onChange(programs.find((program) => program.id === e.target.value))}
      options={programOptions}
      noOptionsText={texts.noProgramsText}
      disabled={isReadOnly}
      label={texts.selectProgram}
      error={hasError}
      inputProps={{
        'aria-invalid': hasError,
        'aria-describedby': hasError ? errorId : undefined,
      }}
    />
  );
};

ChallengeProgramSelector.propTypes = {
  programs: PropTypes.arrayOf(PropTypes.instanceOf(Program)),
  selectedProgramId: PropTypes.string,
  onChange: PropTypes.func,
  isReadOnly: PropTypes.bool,
  hasError: PropTypes.bool,
  errorId: PropTypes.string,
};

ChallengeProgramSelector.defaultProps = {
  programs: [],
  selectedProgramId: '',
  onChange: () => {},
  isReadOnly: false,
  hasError: false,
  errorId: '',
};

export default ChallengeProgramSelector;
